import { OneColumn } from 'components/page';
import { ConfigPedidoMenu } from 'pages/compra/configuracao-pedido/components/form/ConfigPedidoMenu';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';

export function ConfigPedidoForm() {
    const { activeStep } = useConfigPedidoStepContext();

    return (
        <OneColumn title="Configuração de Pedido" goBackButton titleAddon={<ConfigPedidoMenu />}>
            {activeStep.component}
        </OneColumn>
    );
}
